
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admitad-alternative",
      function () {
        return require("private-next-pages/admitad-alternative.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admitad-alternative"])
      });
    }
  